import React, { useState, useEffect, useCallback } from 'react';
import { Icon, Input, Checkbox, Tooltip, Select } from 'antd';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';

import {
    Container,
    SearchBar,
    TemplateTitleSec,
    ContentSection,
    FilterTitle,
    AdvSearchIcon,
    SearchButton,
    SearchTitle,
    EmptySettingsDetails,
} from './styles';

import { ScrollContainer, DesignModal, ModalBody, MenuDrawer } from '../LandingPage/styles';
import SideNav from '../LandingPage/SideNav';
import AddTags from './tagSearch';
import EmptyElementsIllustration from '../../images/empty-elements.svg';

import {
    ADVANCED_FILTER,
    INTERACTIVE_TEMPLATES_LIST
} from './translationValues';
import InteractiveTemplates from './InteractiveTemplates';
import { getAllInteractiveDesigns } from '../../utils/services/interactiveDesignApi';
import { getAllDocumentsByCategories } from '../../utils/services/categoriesAPI';

const NAMESPACES = [
    'INTERACTIVE_TEMPLATES_LIST',
    'ADVANCED_FILTER',
];

const CheckboxGroup = Checkbox.Group;
const InteractiveTemplateSection = ({ t }) => {
    const [categoryList, setCategoryList] = useState([]);
    const [filterCateg, setFilterCateg] = useState(undefined);
    const [searchedValue, setSearchedValue] = useState('');
    const [globalSearchVal, setGlobalSearch] = useState(undefined);
    const [globalSearchTag, setGlobalSearchTag] = useState(undefined);
    const [userpage, setuserpage] = useState(1);
    const [showDrawer, setShowDrawer] = useState(false);
    const [showCategories, setShowCategories] = useState(false);
    const [drawAnimate, setDrawAnimate] = useState(false);
    const [showSearchIcon, setShowSearchIcon] = useState(false);
    const [forApproval, setForApproval] = useState(false);
    const [isScrollToTop, setIsScrollToTop] = useState(false);
    const [checkBoxOptions, setCheckBoxOptions] = useState([]);
    const [modalCheckBoxOptions, setModalCheckBoxOptions] = useState([]);
    const [isClearALLInputs, setIsClearALLInputs] = useState(false);
    const [fetchingCategoryList, setFetchingCategoryList] = useState(true);
    const [fetchingCategoriesList, setFetchingCategoriesList] = useState(true);
    const [totalTemplates, setTotalTemplates] = useState(0);
    const [templatesList, setTemplatesList] = useState([]);
    const [selectedChannels, setSelectedChannels] = useState(undefined);
    const [channel, setChannel] = useState(undefined);

    const channelsList = [
        {
            label: `${t(
                ADVANCED_FILTER.CHANNEL_FILTER_EMAIL_LABEL.key,
                ADVANCED_FILTER.CHANNEL_FILTER_EMAIL_LABEL.value,
            )}`,
            value: "email"
        },
        {
            label: `${t(
                ADVANCED_FILTER.CHANNEL_FILTER_PRINT_LABEL.key,
                ADVANCED_FILTER.CHANNEL_FILTER_PRINT_LABEL.value,
            )}`,
            value: "print"
        }
    ]

    const smoothScroll = () => {
        document.querySelector('#scrollContainer').scrollTop = 0;
    };

    const hideDraw = () => {
        setShowDrawer(false);
        setDrawAnimate(true);
        setShowSearchIcon(false);
        setTimeout(() => {
            setDrawAnimate(false);
        }, 1800);
    };

    const showDraw = () => {
        setShowDrawer(true);
        setTimeout(() => {
            setShowSearchIcon(true);
        }, 1000);
    };

    const globalTagSearch = e => {
        if (e.length === 0) {
            setGlobalSearchTag(undefined);
        } else {
            setuserpage(1);
            setGlobalSearchTag(e);
        }
    };

    const searchTemplate = async () => {
        setuserpage(1);
        setGlobalSearch(searchedValue);
    };

    const clearAllFilters = () => {
        setFilterCateg(undefined);
        setSearchedValue(null);
        setGlobalSearchTag(undefined);
        setIsClearALLInputs(!isClearALLInputs);
        setGlobalSearch(undefined);
        setForApproval(false);
    };

    const globalSearch = e => {
        setSearchedValue(e.target.value);
        if (e.target.value.length === 0) {
            setGlobalSearch(undefined);
        }
    };

    const categoryChange = checkedValues => {
        setuserpage(1);
        let mergeFilterCateg = filterCateg ? [...filterCateg] : [];
        const optionLabels = checkBoxOptions.map(option => option.value);
        if (checkedValues.length > 0) {
            const uncheckedValues = optionLabels.filter(value => !checkedValues.includes(value));
            checkedValues.forEach(value => {
                if (!mergeFilterCateg.includes(value)) {
                    mergeFilterCateg.push(value);
                }
            });
            mergeFilterCateg = mergeFilterCateg.filter(value => {
                return !uncheckedValues.includes(value);
            });
            setFilterCateg(mergeFilterCateg.length > 0 ? mergeFilterCateg : undefined);
        } else {
            mergeFilterCateg = mergeFilterCateg.filter(value => {
                return !optionLabels.includes(value);
            });
            setFilterCateg(mergeFilterCateg.length > 0 ? mergeFilterCateg : undefined);
        }
    };
  

    const getTemplateList = useCallback(async (addData, page = userpage) => {
        try {
            const payload = {
                limit: 8,
                rgPermission: 'write',
                page: page,
                categoryIds: filterCateg,
                tags: globalSearchTag,
                name: searchedValue,
                channel: channel
            };

            const response = await getAllInteractiveDesigns(
                JSON.parse(JSON.stringify(payload))
            );

            if (response?.data) {
                if (addData) {
                    setTemplatesList(prevList => [...prevList, ...response.data]);
                } else {
                    setTemplatesList(response.data);
                }
            } else {
                setTemplatesList([]);
            }

            setTotalTemplates(response?.dataCount || 0);
        } catch (error) {
            console.error('Error fetching template list:', error);
        } finally {
            setFetchingCategoryList(false);
        }
    }, [filterCateg, globalSearchTag, searchedValue, userpage, channel]);

    const fetchingCategory = async () => {
        let response = await getAllDocumentsByCategories(
                     false,
                     false,
                    'usertemplate',
                     false,
                     'write',
                   );
        if(response?.data){
            setCategoryList(response.data);
            setFetchingCategoriesList(false);
        } else if (response?.data?.length === 0) {
            setFetchingCategoriesList(false);
        }      
    }

    useEffect(() => {
        (async function () {
            try {
                setFetchingCategoriesList(true);
                await fetchingCategory();
            } catch (e) {
                console.error(e);
            }
        })();

    }, [])


    const handleScroll = async () => {
        let reference = document.querySelector('#scrollContainer');
        if (reference) {
            if (reference.classList.contains('on-scrollbar') === false) {
                reference.classList.add('on-scrollbar');
            } else {
                setTimeout(() => {
                    if (document.querySelector('#scrollContainer')) {
                        document.querySelector('#scrollContainer').classList.remove('on-scrollbar');
                    }
                }, 500);
            }
            if (
                reference.scrollTop !== 0 &&
                (((reference.scrollHeight - 40) - reference.scrollTop - reference.clientHeight) <= 1)
            ) {
                setuserpage(userpage + 1);
                if (templatesList.length < totalTemplates) {
                    getTemplateList(true, userpage + 1);
                }
            }
            if (reference.scrollTop > 800) {
                setIsScrollToTop(true);
            } else {
                setIsScrollToTop(false);
            }
        }
    };

    useEffect(() => {
        if (categoryList && categoryList?.length > 0) {
            let allCategoryOptions = categoryList?.map(category => ({
                label: category.categoryName,
                value: category.categoryId,
            }));
            let categoryOptions = categoryList
                .slice(0, 5)
                .map(category => ({ label: category.categoryName, value: category.categoryId }));
            setModalCheckBoxOptions(allCategoryOptions);
            setCheckBoxOptions(categoryOptions);
        }
        // eslint-disable-next-line
    }, [categoryList]);

    useEffect(() => {
       getTemplateList(false, 1);
    }, [globalSearchVal, filterCateg, globalSearchTag, forApproval, channel]);

    const onAllCategoryChange = checkedValues => {
        setuserpage(1);
        if (checkedValues.length > 0) {
            setFilterCateg(checkedValues);
        } else {
            setFilterCateg(undefined);
        }
    };

    const onChannelChange = checkedValues => {
        setSelectedChannels(checkedValues);
        if (checkedValues.length === 1) {
            setChannel(checkedValues[0])
        } else {
            setChannel(undefined)
        }
    };


    return (
        <ScrollContainer
            onScroll={_.debounce(handleScroll, 500)}
            id="scrollContainer"
        >
            <SideNav />
            <Container >

                {/* sideNav */}
                <Tooltip
                    placement="left"
                    title={
                        !showDrawer &&
                        t(
                            `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                            ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
                        )
                    }
                >
                    <AdvSearchIcon
                        type={showDrawer ? 'close' : 'search'}
                        showSearchIcon={showDrawer && showSearchIcon}
                        onClick={() => (showDrawer ? hideDraw() : showDraw())}
                    />
                </Tooltip>

                <DesignModal
                    categ={true}
                    title={
                        <p>
                            {t(
                                `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                                ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
                            )}
                            <div className="badge">{categoryList?.length} </div>
                        </p>
                    }
                    centered
                    visible={showCategories}
                    onOk={() => setShowCategories(false)}
                    onCancel={() => setShowCategories(false)}
                    footer={null}
                    mask={false}
                    className={'design_modal_categ'}
                >
                    <ModalBody>
                        <CheckboxGroup
                            options={modalCheckBoxOptions}
                            value={filterCateg}
                            onChange={onAllCategoryChange}
                        />
                    </ModalBody>
                </DesignModal>

                <MenuDrawer
                    SearchDrawer={true}
                    className={showDrawer ? 'drawVisible' : drawAnimate ? 'drawAnimate' : 'drawInVisible'}
                >
                    <div className={!showDrawer ? 'switch' : 'switch_searchBar'} />
                    <div className="searchDrawer">
                        {showDrawer && (
                            <ContentSection>
                                <SearchTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                                        ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
                                    )}
                                </SearchTitle>
                                <FilterTitle className={'clearFilter'} onClick={() => clearAllFilters()}>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_CLEAR_ALL.key}`,
                                        ADVANCED_FILTER.FILTER_CLEAR_ALL.value,
                                    )}
                                </FilterTitle>
                                <FilterTitle>
                                    {' '}
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_NAME_LABEL.value,
                                    )}
                                </FilterTitle>
                                <SearchBar className={'focused'}>
                                    <Input
                                        autoComplete="off"
                                        name="nameSearch"
                                        placeholder={t(
                                            `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.key}`,
                                            ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.value,
                                        )}
                                        onChange={e => globalSearch(e)}
                                        allowClear
                                        value={searchedValue}
                                        onPressEnter={() => searchTemplate()}
                                    />
                                </SearchBar>
                                <FilterTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
                                    )}
                                </FilterTitle>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}
                                >
                                    {fetchingCategoriesList ? (
                                        <Icon type="loading" />
                                    ) : categoryList?.length > 0 ? (
                                        <>
                                            <CheckboxGroup
                                                options={checkBoxOptions}
                                                value={filterCateg}
                                                onChange={categoryChange}
                                            />
                                            {categoryList?.length > 5 && (
                                                <div
                                                    onClick={() => setShowCategories(true)}
                                                    style={{
                                                        fontFamily: 'Raleway,sans-serif',
                                                        fontSize: '15px',
                                                        fontWeight: 700,
                                                        marginTop: '10px',
                                                        cursor: 'pointer',
                                                        color: 'rgb(219,57,31) ',
                                                    }}
                                                >
                                                    {`+${categoryList.length - 5}` +
                                                        t(
                                                            `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.key}`,
                                                            ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.value,
                                                        )}
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <EmptySettingsDetails>
                                            <div className="empty-illustration">
                                                <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
                                            </div>
                                            <div className="empty-txt" style={{ color: '#fff' }}>
                                                <span>
                                                    {t(
                                                        `ADVANCED_FILTER:${ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.key}`,
                                                        ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.value,
                                                    )}
                                                </span>
                                            </div>
                                        </EmptySettingsDetails>
                                    )}
                                </div>
                                
                                <FilterTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CHANNEL_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_CHANNEL_LABEL.value,
                                    )}
                                </FilterTitle>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}
                                >
                                    {(
                                        <>
                                            <CheckboxGroup
                                                options={channelsList}
                                                value={selectedChannels}
                                                onChange={onChannelChange}
                                            />
                                        </>
                                    )}
                                </div>

                                <FilterTitle>
                                    {t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.key}`,
                                        ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.value,
                                    )}
                                </FilterTitle>
                                <AddTags
                                    globalTagSearch={e => globalTagSearch(e)}
                                    clearALLTags={isClearALLInputs}
                                    checked={globalSearchTag}
                                    placeholder={t(
                                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.key}`,
                                        ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.value,
                                    )}
                                />

                                <div className="button">
                                    <SearchButton
                                        onClick={() => {
                                         getTemplateList(false, 1)
                                        }}
                                    >
                                        {t(
                                            `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SEARCH_BUTTON.key}`,
                                            ADVANCED_FILTER.FILTER_SEARCH_BUTTON.value,
                                        )}
                                    </SearchButton>
                                </div>
                            </ContentSection>
                        )}
                    </div>
                </MenuDrawer>

                <TemplateTitleSec>
                    <p className={'template_title'}>
                        {t(
                            `INTERACTIVE_TEMPLATES_LIST:${INTERACTIVE_TEMPLATES_LIST.INTERACTIVE_TEMPLATES_TITLE.key}`,
                            INTERACTIVE_TEMPLATES_LIST.INTERACTIVE_TEMPLATES_TITLE.value,
                        )}
                    </p>

                    <p className={'template_desc'}>
                        {t(
                            `INTERACTIVE_TEMPLATES_LIST:${INTERACTIVE_TEMPLATES_LIST.INTERACTIVE_TEMPLATES_DESCRIPTION.key}`,
                            INTERACTIVE_TEMPLATES_LIST.INTERACTIVE_TEMPLATES_DESCRIPTION.value,
                        )}
                    </p>

                </TemplateTitleSec>

                {/* template list */}
                <InteractiveTemplates
                    categoryList={categoryList}
                    forApproval={forApproval}
                    templatesList={templatesList}
                    fetchingCategories={fetchingCategoryList}
                    totalTemplates={totalTemplates}
                />
            </Container>
            {isScrollToTop && (
                <Tooltip placement="left" title={'Scroll to top'}>
                    <Icon type="arrow-up" onClick={() => smoothScroll()} />
                </Tooltip>
            )}
        </ScrollContainer>
    )
}

export default withTranslation(NAMESPACES)(InteractiveTemplateSection);
